import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useEffect, useRef, useState } from 'react'

import { ApolloError } from '@apollo/client'

import { Alert } from './Alert'

export const SearchInput = ({
  inputValue,
  setInput,
  error,
  clearInput,
  searchParams,
  updateSearchParams,
}: {
  inputValue: string
  setInput: (value: string) => void
  dataSource: string
  error: ApolloError | undefined
  clearInput: () => void
  searchParams?: URLSearchParams
  updateSearchParams?: (params: Record<string, string>) => void
}) => {
  const [isHovered, setIsHovered] = useState(false)

  const errorRef = useRef<HTMLInputElement>(null)

  // Set the input value to the query param if it exists
  useEffect(() => {
    const query = searchParams?.get('query')
    if (query && query !== inputValue) {
      setInput(query)
    }
  }, [])

  useEffect(() => {
    if (updateSearchParams && searchParams) {
      updateSearchParams({ query: inputValue })
    }
  }, [updateSearchParams, searchParams, inputValue])

  return (
    <div className="relative w-full rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-6 focus:border-gray-500 focus:outline-none">
      <label htmlFor="search" className="inline-blocktext-xs font-medium text-gray-900">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>
      </label>
      <input
        ref={errorRef}
        type="text"
        name="search"
        id="search"
        data-testid="search"
        className="z-0 block w-full border-0 p-0 pl-8 text-gray-900 placeholder:text-gray-300 focus:ring-0 sm:text-sm"
        placeholder={`has:resource[service.name]`}
        value={inputValue}
        onChange={(e) => setInput(e.target.value)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
      {inputValue && (
        <div
          className="absolute inset-y-0 right-0 z-10 flex cursor-pointer items-center justify-center rounded-r-md p-3 hover:bg-gray-100"
          onClick={() => {
            updateSearchParams && updateSearchParams({ query: '' })
            clearInput()
          }}>
          <XMarkIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>
      )}
      {isHovered && error && <Alert error={error.message} />}
    </div>
  )
}
